var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-chart-1"},[_c('div',{staticClass:"lc1-header"},[_vm._v("总体进度")]),_c('div',{staticClass:"lc1-details"},[_vm._v("总场数"),_c('span',[_vm._v(_vm._s(_vm.all.scene))]),_vm._v("总人数"),_c('span',[_vm._v(_vm._s(_vm.all.attendance))])]),_c('dv-decoration-2',{staticStyle:{"height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }